import ReactGA from 'react-ga4';

// Inizializza Google Analytics 4
export const initGA = () => {
  const measurementId = 'G-5Y46C89M2X';
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  ReactGA.initialize(measurementId, {
    gaOptions: {
      debug_mode: isDevelopment,
    },
    gtagOptions: {
      debug_mode: isDevelopment,
    },
  });

  // Log in console per confermare l'inizializzazione
  if (isDevelopment) {
    console.log('GA4 inizializzato:', measurementId);
  }
};

// Traccia una pageview
export const trackPageView = (page: string, title?: string) => {
  const pageData = { 
    hitType: 'pageview', 
    page,
    title: title || page
  };
  
  ReactGA.send(pageData);
  
  // Log in console in development
  console.log('GA4 Pageview:', pageData);
};

// Traccia un evento personalizzato
export const trackEvent = (category: string, action: string, label?: string) => {
  const eventData = {
    category,
    action,
    label,
  };
  
  ReactGA.event(eventData);
  
  console.log('GA4 Event:', eventData);
};

// Traccia un click su un pulsante
export const trackButtonClick = (buttonName: string) => {
  trackEvent('Button', 'Button - Click', buttonName);
};

// Traccia la registrazione utente
export const trackUserRegistration = (method?: string) => {
  trackEvent('User', 'User - Registration', method);
};

// Traccia il completamento del tutorial
export const trackTutorialComplete = () => {
  trackEvent('Tutorial', 'Tutorial - Complete');
};

// Traccia la visualizzazione di un video
export const trackVideoView = (artistName: string) => {
  trackEvent('Video', 'Video - View', artistName);
};

// Traccia un voto
export const trackPlay = (dataPlay: string) => {
  trackEvent('Play', 'Play - Submit', dataPlay);
};

